const Error = () => {
  return (
    <div className="p-4 text-center">
      <h1 className="text-red-500 font-bold text-2xl">404 - Page Not Found</h1>
    </div>
  );
};

export default Error;
